// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-04-27
import React, { useMemo } from 'react';
import { IconRemove } from 'src/content/icons';
import ScrollBar from 'src/components/ScrollBar/ScrollBar';
import { strings } from 'src/localization';
import css from './CalendarSelectAppt.module.scss';

interface IProps {
    title: string;
    information: string;
    onClose: (e: React.MouseEvent<SVGSVGElement>) => void;
    theme?: string;
    colorSensitiveEnabled?: boolean;
}

/** Displays a transportation option's title and description in a scrollable info panel with a close button. */
const CalendarSelectApptInfo = (props: IProps) => {
    const { title, information, onClose, theme, colorSensitiveEnabled } = props;
    // Split information on newlines to reflect char returns in specs
    const informationDivs = useMemo(() => information.split('\n').map(
        (info, index) => <div key={index} className={css.infoDivs}>{info}</div>),
    [information]);

    return (
        <div>
            <IconRemove
                id={'CalendarSelectApptInfo-closeBtn'}
                data-testid={'CalendarSelectApptInfo-closeBtn'}
                onClick={onClose}
                className={css.removeIcon}
                aria-label={strings.Close}
            />
            <ScrollBar scrollHorizontal theme={theme} colorSensitiveEnabled={colorSensitiveEnabled}>
                <h2>{title}</h2>
                <div>
                    {informationDivs}
                </div>
            </ScrollBar>
        </div>
    );
};

export default CalendarSelectApptInfo;